export default {
  routes: [
    /*  登录页 */
    {
      path: "/",
      name: "Login",
      meta: {
        auth: true,
      },
      component: () => import("@/view/login/index.vue"),
    },
    /* 管理端 */
    {
      path: "/management",
      name: "Management",
      component: () => import("@/view/management/index.vue"), //导航
      // redirect: "/management/supAdmin", //重定向到第一个子路由
      children: [
        /* 超级管理员 */
        {
          path: "accounts",
          name: "SupAdmin",
          component: () => import("@/view/management/accounts/index.vue"), //导航
          children: [
            {
              path: "admin",
              name: "MallAdmin",
              component: () =>
                import("@/view/management/accounts/admin/index.vue"),
            },
          ],
        },
        //工作区
        {
          path: "workspace",
          name: "Workspace",
          component: () => import("@/view/management/workspace/index.vue"),
        },
        /* 权限 */
        {
          path: "accounts/subAdmin",
          name: "PermissionAdmin",
          component: () =>
            import("@/view/management/accounts/subAdmin/index.vue"),
        },

        /* 系统参数配置 */
        {
          path: "sysConfig",
          name: "SysConfig",
          component: () => import("@/view/management/sysConfig/index.vue"),
        },
        /* 用户管理 */
        {
          path: "user",
          name: "UserManagement",
          component: () => import("@/view/management/user/index.vue"),
          children: [
            {
              path: "userList",
              name: "MemberList",
              component: () => import("@/view/management/user/userList.vue"),
            },
            {
              path: "transactions",
              name: "MemberRecord",
              component: () =>
                import("@/view/management/user/transactions.vue"),
            },
          ],
        },

        /* 网站设置 */
        {
          path: "webCenter",
          name: "WebCenter",
          component: () => import("@/view/management/webCenter/index.vue"),
          children: [
            {
              path: "feedback",
              name: "Feedback",
              component: () =>
                import("@/view/management/webCenter/feedback.vue"),
            },
            {
              path: "notifications",
              name: "Notifications",
              component: () =>
                import("@/view/management/webCenter/notifications.vue"),
            },
          ],
        },
        /* 机构管理（原博物馆管理） */
        {
          path: "institution",
          name: "Institution",
          component: () => import("@/view/management/institution/index.vue"),
          children: [
            {
              path: "institutionList",
              name: "InstitutionList",
              component: () =>
                import(
                  "@/view/management/institution/institutionList/institutionList.vue"
                ),
            },
            {
              path: "institutionTypes",
              name: "InstitutionTypes",
              component: () =>
                import(
                  "@/view/management/institution/InstitutionTypes/institutionTypes.vue"
                ),
            },
            {
              path: "exhibitionList",
              name: "ExhibitionList",
              component: () =>
                import(
                  "@/view/management/institution/exhibitionList/exhibitionList.vue"
                ),
            },
          ],
        },
        /* 作品管理 */
        {
          path: "artworkManage",
          name: "ArtworkManage",
          component: () => import("@/view/management/artworkManage/index.vue"),
          children: [
            {
              path: "countryCities",
              name: "CountryCities",
              component: () =>
                import("@/view/management/artworkManage/countryCities.vue"),
            },
          ],
        },
      ],
    },
    /* 其他页 */
    {
      path: "/errow",
      name: "Errow",
      component: () => import("@/view/error/index.vue"),
    },
  ],
};
